// Para birimi yardımcıları
// Uygulamanın ana para birimi EURO'dur. Ürün listesine USD veya TRY olarak
// fiyat girilebilir; listeleme ve siparişlerde her zaman EUR karşılığı kullanılır.

export const BASE_CURRENCY = 'EUR';

export const CURRENCIES = {
  EUR: { code: 'EUR', symbol: '€', label: 'Euro' },
  USD: { code: 'USD', symbol: '$', label: 'ABD Doları' },
  TRY: { code: 'TRY', symbol: '₺', label: 'Türk Lirası' },
};

export const CURRENCY_CODES = Object.keys(CURRENCIES);

export const getCurrencySymbol = (code) => CURRENCIES[code]?.symbol || '€';

// Ürünlerde fiyat taşıyan alanlar (satış + maliyet)
export const PRODUCT_PRICE_FIELDS = [
  'unitPrice',
  'merdivenIpliFiyat',
  'kurdeleliFiyat',
  'merdivenIpliReduktorluFiyat',
  'kurdelaliReduktorluFiyat',
  'cost',
  'merdivenIpliMaliyet',
  'kurdeleliMaliyet',
  'merdivenIpliReduktorluMaliyet',
  'kurdelaliReduktorluMaliyet',
];

/**
 * Excel / serbest metin para birimi değerini standart koda çevirir.
 * Boş veya tanınmayan değerlerde EUR döner.
 */
export const normalizeCurrency = (value) => {
  const v = (value ?? '').toString().trim().toUpperCase();
  if (!v) return BASE_CURRENCY;
  if (['EUR', 'EURO', '€', 'AVRO'].includes(v)) return 'EUR';
  if (['USD', 'DOLAR', 'DOLLAR', '$', 'US$'].includes(v)) return 'USD';
  if (['TRY', 'TL', '₺', 'LIRA', 'TÜRK LIRASI', 'TURK LIRASI'].includes(v)) return 'TRY';
  return BASE_CURRENCY;
};

/** Para birimi değeri geçerli mi? (Excel doğrulaması için) */
export const isKnownCurrency = (value) => {
  const v = (value ?? '').toString().trim();
  if (!v) return true; // boş => EUR
  const upper = v.toUpperCase();
  return ['EUR', 'EURO', '€', 'AVRO', 'USD', 'DOLAR', 'DOLLAR', '$', 'US$', 'TRY', 'TL', '₺', 'LIRA', 'TÜRK LIRASI', 'TURK LIRASI'].includes(upper);
};

/**
 * Canlı kurları çeker. Dönen değerler "1 EUR = X birim" formatındadır.
 * örn. { USD: 1.08, TRY: 37.5 }
 */
export const fetchEurRates = async () => {
  const res = await fetch('https://open.er-api.com/v6/latest/EUR');
  const data = await res.json();
  if (data && data.rates && data.rates.USD && data.rates.TRY) {
    return { USD: Number(data.rates.USD), TRY: Number(data.rates.TRY) };
  }
  throw new Error('Kur bilgisi alınamadı');
};

/**
 * Manuel kur ayarı açıksa onu, değilse canlı kuru kullanır.
 * settings: { useManualRates, manualUsdRate, manualTryRate }
 */
export const getEffectiveRates = (liveRates = {}, settings = {}) => {
  const live = { USD: Number(liveRates.USD) || 0, TRY: Number(liveRates.TRY) || 0 };
  if (!settings.useManualRates) return live;
  return {
    USD: Number(settings.manualUsdRate) || live.USD,
    TRY: Number(settings.manualTryRate) || live.TRY,
  };
};

/** Tutarı verilen para biriminden EUR'ya çevirir. Kur yoksa tutar aynen döner. */
export const toEur = (amount, currency, rates = {}) => {
  const num = parseFloat(amount);
  if (isNaN(num)) return amount;
  const code = normalizeCurrency(currency);
  if (code === 'EUR') return num;
  const rate = Number(rates[code]);
  if (!rate) return num;
  return Math.round((num / rate) * 100) / 100;
};

/**
 * Ürünü EUR'ya çevrilmiş fiyatlarla döndürür.
 * Orijinal değerler `originalPrices` içinde, orijinal para birimi `currency` alanında kalır.
 */
export const convertProductToEur = (product, rates) => {
  const currency = normalizeCurrency(product?.currency);
  if (!product || currency === 'EUR') return { ...product, currency: 'EUR' };
  const converted = { ...product, currency, originalPrices: {} };
  PRODUCT_PRICE_FIELDS.forEach((field) => {
    if (product[field] !== undefined && product[field] !== '' && product[field] !== null) {
      converted.originalPrices[field] = product[field];
      converted[field] = toEur(product[field], currency, rates);
    }
  });
  return converted;
};
